import ElementStateReporter from './components/ElementStateReporter';
import Thanks from './components/Thanks';
import SportApp from './components/SportApp';

/**
 * Initialise element state reporter for one list
 * @param  {string} containerSelector
 *         The container selector to watch for mutations. This will also
 *         form part of the query selector for elements to watch/position.
 * @param  {string} elemSelector
 *         A selector string for elements that need position calculating
 * @param  {string} positionAttr
 *         A string for the attribute for position tracking
 * @return {void}
 */
const initEsr = function (containerSelector, elemSelector, positionAttr) {
    const container = document.querySelector(containerSelector);

    if (container !== null) {
        const elementStateReporter = new ElementStateReporter(
            container,
            elemSelector,
            positionAttr || null
        );

        elementStateReporter.init();
    }
};

/**
 * Initialise element state reporter for multiple lists
 *
 * @param {string} groupSelector
 *        The container selector to watch for mutations. This will also
 *        form part of the query selector for elements to watch/position.
 * @param {string} elemSelector
 *        A selector string for elements that need position calculating
 * @param  {string} positionAttr
 *         A string for the attribute for position tracking
 * @return {void}
 */
const initGroupedEsr = function (groupSelector, elemSelector, positionAttr) {
    const groups = [...document.querySelectorAll(groupSelector)];

    if (groups.length > 0) {
        groups.forEach(container => {
            const elementStateReporter = new ElementStateReporter(
                container,
                elemSelector,
                positionAttr || null
            );

            elementStateReporter.init();
        });
    }
};

window.addEventListener('DOMContentLoaded', () => {
    const sportApp = new SportApp();

    sportApp.init();
});

window.addEventListener('load', () => {
    const thanks = new Thanks();

    thanks.init();

    initEsr('.homepage.reflex', '.pnState');
    initEsr('.existing-customer-homepage', '.pnState', 'data-interaction-module-position');
    initEsr('.signup', '.popup-content .fibre-upsell-product');
    initEsr('.dealsHubLanding', '.pnState');
    initEsr('.pn-perks__tiles-list', '.pnState');
    initEsr('.pn-thanks', '.pnState');
    initEsr('.pn-ac-card__contain', '.pnState');
    initEsr('.pn-ac-main', '.pnState');
    initEsr('.dInnerContentUpgrade', '.pnState', 'data-interaction-module-position');
    initEsr('.billingTab', '.pnState', 'data-interaction-module-position');

    initGroupedEsr('[data-ecom-list]', '[data-ecom-product]', 'data-ecom-position');

    if (document.body.classList.contains('productGuide')) {
        initGroupedEsr('.tabs [data-section]', '[data-ecom-promotion]', 'data-ecom-position');
    } else {
        // We're not on a packages guide page
        initGroupedEsr('[data-section]', '[data-ecom-promotion]', 'data-ecom-position');
    }
});
